export function slugifyURL({ _id, companyName, jobTitle }) {
	const cleanedJobTitle = jobTitle
		.replace(/[^a-zA-Z0-9\s-]/g, "")
		.trim()
		.replace(/\s+/g, "-")
		.replaceAll("--", "-")
		.toLowerCase();
	const cleanedCompanyName = companyName
		.replace(/[^a-zA-Z0-9\s-]/g, "")
		.trim()
		.replace(/\s+/g, "-")
		.replaceAll("--", "-")
		.toLowerCase();

	// replace all double dashes with single dashes
	const url = `${cleanedJobTitle}-at-${cleanedCompanyName}-${_id}`.replaceAll("--", "-");

	return url;
}

export function unSlugifyURL(slug) {
	if (!slug) return "";

	const parts = slug.split("-");
	const id = parts.pop();

	return id;
}
